<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Pauk karte ({{ totalRecords }})</h3>
                    </template>
                    <div class="row">
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp" format="dd.MM.yyyy. HH:mm:ss"
                                    v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp" format="dd.MM.yyyy. HH:mm:ss"
                                    v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Tip</h4>
                            <base-input>
                                <el-select v-model="filter.ticketType" class="select-primary" name="zone" clearable @clear="filter.ticketType = null">
                                    <el-option v-for="zone in ticketTypes" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Pauk lokacija</h4>
                            <el-select v-model="filter.paukLocation" class="select-primary" value-key="id"
                                name="kioskGroups"  clearable >
                                <el-option v-for="t in paukLocations" class="select-primary" :label="t.name" :value="t"
                                    :key="t.id"></el-option>
                            </el-select>
                        </div>
                        
                        
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getTickets()">Pretraži</base-button>

                        </div>
                    </div>
                    

                    <el-table :data="tickets" v-loading="ticketsLoading" @sort-change="handleSort"
                        :default-sort="{ prop: sortField, order: sortOrder }">

                        

                        <el-table-column min-width="130" prop="stamp" label="Datum" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="serviceNumber" label="Zaposleni">
                            <template slot-scope="scope">
                                <span>{{ scope.row.user?.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="plates" label="Tablice">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="vehicle" label="Vozilo">
                            <template slot-scope="scope">
                                <span>{{ scope.row.vehicle }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="200" prop="street" label="Ulica">
                            <template slot-scope="scope">
                                <span>{{ scope.row.street }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="200" prop="ticketType" label="Tip">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ticketType === 0" style="color: aquamarine;" >ODNOŠENJE</span>
                                <span v-if="scope.row.ticketType === 1" style="color: cadetblue;">LISICE</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="200" prop="paukLocationId" label="Pauk lokacija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.paukLocation?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="130" prop="returned_stamp" label="Razduženo" sortable="custom">
                            <template slot-scope="scope">
                                <span v-if="scope.row.returnedStamp">{{ (new Date(scope.row.returnedStampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        

                        <el-table-column min-width="200" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <base-button :type="'success'" class="btn-link" @click="getTicket(scope.row)">
                                    Detalji
                                </base-button>

                            </div>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>
        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false; ticket = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <div class="row">
                <div class="col-md-12">
                    <card>
                        Opis: {{ ticket.description }}<br>
                        {{ ticket.plates }}<br>
                        {{ ticket.street }}<br>
                        {{ ticket.vehicle }}<br>
                        <base-button v-if="!ticket.returnedStamp" class="mt-3" native-type="submit" type="primary"
                                @click="razduziDialog()">Razduži</base-button>
                    </card>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <card>
                        <template v-for="img in ticket.images">
                        <img class="card-img" style="width: 150px;"
                            @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                    </card>
                </div>

            </div>
            
            

        </modal>
        <modal :show.sync="showImage" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showImage = false; image = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">{{ ticket.plates }}</h4>
                <img class="card-img" :src="image" alt="Image" />&nbsp;

            </card>


        </modal>

        
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem, BasePagination } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'
import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const rows = [
    { value: 10, name: "10" },
    { value: 20, name: "20" },
    { value: 50, name: "50" },
    { value: 100, name: "100" }
]

const ticketTypes = [
    { id: 0, name: "ODNOSENJE" },
    { id: 1, name: "LISICE" }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal,
        BasePagination
    },
    mounted() {
        this.getTickets()
        // this.getPaukTypes()
        this.getPaukLocations()
        this.user = JSON.parse(localStorage.getItem("user"));
        // console.log("User", this.user);
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            ticketTypes,
            rows,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            ticketsLoading: false,
            loading: false,
            tickets: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                ticketType: null,
                plates: null,
                paukLocation: null
            },
            paukLocations: [],
            ticketsLoading: false,
            ticket: {},
            showTicket: false,
            image: null,
            showImage: false,
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            sortField: "stamp",
            sortOrder: "descending",
            user: {},
            paukTypes: []
        };
    },
    methods: {
        razduziDialog(){
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da razdužite vozilo \"" + this.ticket.plates + "\"?",
                    text: ``,
                    confirmButtonText: "Da",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.razduzi()
                    }
                });
        },
        changeP(item) {
            this.page = item
            this.getTickets()
        },
        handleSort({ prop, order }) {
            this.sortField = prop;
            this.sortOrder = order;

            this.getTickets()
        },
        razduzi() {
            this.loading = true

            axios.post(this.url + '/pauk/razduzi', this.ticket).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            "Razduzeno",
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.showTicket = false
                    this.getTickets()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getPaukLocations() {
            this.loading = true

            axios.get(this.url + '/pauk/getPaukLocations').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.paukLocations = result.data.paukLocations
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getPaukTypes() {

            axios.get(this.url + '/pauk/getPaukTypes').then(result => {

                if (result.data.result === 'ok') {
                    this.paukTypes = result.data.paukTypes
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        
        getTicket(t) {
            this.loading = true

            axios.get(this.url + '/pauk/getTicket?id=' + t.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.ticket = result.data.ticket
                    this.showTicket = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        
        getTickets() {
            this.ticketsLoading = true
            const f = this.filter
            f.page = this.page
            f.max = this.max
            f.sortField = this.sortField
            f.sortOrder = this.sortOrder
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/pauk/getTickets', f).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        
        navigateToPage() {
            this.$router.push({ name: 'Administration' });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da parking mesto \"" + this.parkingSpace.number + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteParkingSpace()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        saveTicketPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Molimo vas unesite komentar za ovu promenu.",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.ticket.comment = comment;
                        this.saveTicket()
                    }
                });
        }

    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>